import { useProposalT } from "../i18n/ProposalI18nContext";

interface FlexCreditsSectionProps {
  flexCredits: number;
  creditsPrice?: number;
}

export function FlexCreditsSection({
  flexCredits,
  creditsPrice = 80,
}: FlexCreditsSectionProps) {
  const { t } = useProposalT();
  if (!flexCredits || flexCredits <= 0) return null;

  const estimatedValue = flexCredits * creditsPrice;

  const handleLearnMore = (e: React.MouseEvent) => {
    e.preventDefault();
    document
      .getElementById("rede-woba")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="font-space-grotesk">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          className="flex md:inline-flex w-full md:w-auto gap-4 md:gap-6"
          style={{
            alignItems: "center",
            flexWrap: "wrap",
            padding: "18px 20px",
            borderRadius: "14px",
            background: "#FFFFFF",
            border: "1px solid #F0E9D8",
          }}
        >
          {/* Lightning icon */}
          <div
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "9px",
              background: "#FFF3CC",
              border: "1px solid rgba(184,134,11,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#B8860B"
              strokeWidth="2.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
            </svg>
          </div>

          {/* Text hierarchy */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <span
              style={{
                display: "block",
                fontSize: "11px",
                fontWeight: 600,
                letterSpacing: "0.06em",
                textTransform: "uppercase",
                color: "#B8860B",
                marginBottom: "3px",
              }}
            >
              {t("flexCredits.label")}
            </span>
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                gap: "5px",
              }}
            >
              <span
                style={{
                  fontSize: "22px",
                  fontWeight: 800,
                  color: "#1A1814",
                  letterSpacing: "-0.02em",
                  lineHeight: 1,
                  fontFamily: "'Space Grotesk', sans-serif",
                }}
              >
                {flexCredits.toLocaleString("pt-BR")}
              </span>
              <span
                style={{ fontSize: "14px", color: "#4A453F", fontWeight: 500 }}
              >
                {t("flexCredits.perMonth")}
              </span>
            </div>
            <p
              style={{
                fontSize: "12px",
                color: "#9E9A94",
                margin: "3px 0 0",
                fontWeight: 400,
              }}
            >
              {t("flexCredits.estimatedValue", {
                value: estimatedValue.toLocaleString("pt-BR"),
              })}
            </p>
          </div>

          {/* Saiba Mais button */}
          <a
            href="#rede-woba"
            onClick={handleLearnMore}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              padding: "8px 16px",
              borderRadius: "8px",
              background: "transparent",
              border: "1px solid rgba(184,134,11,0.35)",
              color: "#B8860B",
              fontSize: "12px",
              fontWeight: 600,
              textDecoration: "none",
              transition: "background 0.15s, border-color 0.15s",
              flexShrink: 0,
              letterSpacing: "0.01em",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#FFF3CC";
              e.currentTarget.style.borderColor = "rgba(184,134,11,0.6)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.borderColor = "rgba(184,134,11,0.35)";
            }}
          >
            {t("flexCredits.learnMore")}
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}
